import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseRepository } from '../../Common/Data/base.repository';
import { Observable } from 'rxjs';

@Injectable()
export class TaxFeedLogRepository extends BaseRepository {
    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    getList(searchModel: Core.TaxFeedSummaryLogSearchModel): Observable<Compliance.QueryResultModel<Core.TaxFeedSummaryLogModel>> {
        return this.httpPost('/api/diagnostics/taxFeed/summary', searchModel);
    }

    getDetail(searchModel: Core.TaxFeedDiagnosticsDetailSearchModel): Observable<Core.TaxFeedDiagnosticsDetailModel> {
        return this.httpPost(`/api/diagnostics/taxFeed/detail`, searchModel);
    }
}
